export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export enum HeaderTypes {
  COMMENTS = 'Comments',
  CHAT = 'Live Chat',
  ADD_NOTES = 'Add Notes',
}

export enum HttpStatus {
  STATUS_CODE_412 = 412,
}

export enum SlideMode {
  COMMENT = 'COMMENT',
  CHAT = 'CHAT',
  ASKSAARTHI = 'ASKSAARTHI',
  DOUBT = 'DOUBT',
  NOTE = 'NOTE',
  NOTES = 'NOTES',
  LEADERBOARD = 'LEADERBOARD',
  VIDEO_COPILOT = 'VIDEO_COPILOT',
  TIMELINE = 'TIMELINE',
  POLL = 'POLL',
  PLAYLIST = 'PLAYLIST',
  DPP = 'DPP',
  PERSONALTEACHER = 'PERSONALTEACHER',
  THREED = 'THREED',
  TOPICTIMESTAMP = 'TOPICTIMESTAMP',
  ATTACHMENT = 'ATTACHMENT',
  LINK = 'Link',
  SLIDEMAKER_LINK = 'SlidemakerLink',
  RECORDED_POLL = 'RECORDEDPOLL',
  EMPTY = '',
}

export enum VideoType {
  MP4 = 'MP4',
  YOUTUBE = 'youtube',
  AWS_VIDEO = 'awsVideo',
  PENPENCIL_VDO = 'penpencilvdo',
}

export enum VType {
  OTT = 'OTT',
  OTT_DPP = 'OTT_DPP',
  OLD_QBG = 'OLD_QBG',
}

export enum UrlType {
  MP4 = 'MP4',
  YOUTUBE = 'youtube',
  AWS_VIDEO = 'awsVideo',
  PENPENCIL_VDO = 'penpencilvdo',
  PREMIUM_WEB_RTC = 'premiumWebrtc',
}

export enum EmbeddedVideoType {
  MP4 = 'mp4',
  PenPencilVDO = 'penpencilvdo',
  YouTube = 'youtube',
  AWSVideo = 'awsvideo',
}

export enum VideoEntryPoint {
  BATCH_LECTURE_VIDEOS = 'BATCH_LECTURE_VIDEOS',
  BATCH_DPP_VIDEOS = 'BATCH_DPP_VIDEOS',
  BATCH_TODAYS_CLASS_VIDEOS = 'BATCH_TODAYS_CLASS_VIDEOS',
  BATCH_DEMO_VIDEOS = 'BATCH_DEMO_VIDEOS',
  RECENTLY_WATCHED_VIDEOS = 'RECENTLY_WATCHED_VIDEOS',
  SCHEDULED_CLASS_VIDEOS = 'SCHEDULED_CLASS_VIDEOS',
  CONTINUE_LEARNING_VIDEOS = 'CONTINUE_LEARNING_VIDEOS',
  ADMIN_BATCHES_PREVIEW_VIDEOS = 'ADMIN_BATCHES_PREVIEW_VIDEOS',
  KHAZANA_LECTURE_VIDEOS = 'KHAZANA_LECTURE_VIDEOS',
  KHAZANA_LIBRARY_LECTURE = 'KHAZANA_LIBRARY_LECTURE',
}

export enum VideoTypes {
  BATCHES = 'BATCHES',
  RECORDED = 'RECORDED',
  ADMIN = 'ADMIN',
}

export enum CameFrom {
  XYLEM = 'XYLEM',
  STUDIO_X = 'STUDIO_X',
  MED_ED = 'NEET_PG',
  SARRTHI_IAS = 'SARRTHI_IAS',
}

export enum SHOW_NOTIFICATION_TITLE_ENUM {
  PREMIUM_BATCH_PURCHASE = 'This is a premium feature. Please purchase batch to access',
}
export enum UserSegment {
  PAID = 'PAID',
  FREE = 'FREE',
}
export enum CJRShareText {
  MESSAGE = 'Just learned something awesome on CuriousJr, sharing it with you!',
  NOTIFICATION_TITLE = 'Link copied!',
  NOTIFICATION_DESCRIPTION = 'Share link has been copied to clipboard',
  NOTIFICATION_TITLE_ERROR = 'Copy Failed',
  NOTIFICATION_DESCRIPTION_ERROR = 'Unable to copy link. Please try again.',
}

export const DEFAULT_DPP_VIDEOS_THUMBNAIL_URL =
  process.env.REACT_APP_IMAGE_BASE_URL +
  '5eb393ee95fab7468a79d189/ADMIN/ed4e8594-e1f2-4fca-a1f9-0174c5366abc.png';

export enum PlayingSourceEnums {
  SKILLS = 'SKILLS',
}

export const VIDEO_SOURCE = 'PW';
export const VIDEO_TYPE = 'penpencil-vdo';
export const DEVICE_TYPE = 'Desktop';
export const ENTRY_POINT_DELIMITER = '_';
export const ENTRYPOINT_MISSING = 'ENTRYPOINT_MISSING';
export const DISTINCTBASEURL = 'distinctBaseURL';
export const VIDEO_SRC = 'videoSrc';
export const VTYPE = 'vType';
export const OLD_QBG = 'OLD_QBG';
export const ERPTOKEN = 'erpToken';
export const EXPECTED_QUERY_ORDER = ['src', 'type', 'three_dots', 'is_products_enabled'];
export const VIDEO_TYPE_OLD_QBG = 'OLD_QBG';
export const TESTGROUP = 'TestGroup';

export enum videoSyncStatsEvent {
  SESSION_BREAK = 'session_break',
  PAUSED = 'paused',
  STREAM_SYNC = 'stream_sync',
  EXIT_VIDEO = 'exit_video',
  SEEK_BAR_SHIFTED = 'seek_bar_shifted',
  EXIT = 'exit',
}
export const leaveLectureXPBoostMessages = [
  'Earn 20 XP by watching 10 min more. Keep going!',
  'Hold on! Watch 10 more mins and pocket +20 XP',
  'Stay a bit longer and grab +20 XP in just 10 mins!',
];

export const lectureLeaveFriction = 'leave-lecture-friction-relaunch';

export enum OrganizationsName {
  PHYSICSWALLAH = 'Physicswallah',
}

export const PLAYING_SOURCE = 'playingSource';

export const BROWSER_UNLOAD = 'browser_unload';

export const viewModes = {
  EMBEDDED: 'EMBEDDED',
  FULLSCREEN: 'FULLSCREEN',
} as const;

export enum LocalStorageKeys {
  RECORD_POLL_TOOLTIP_COUNT = 'recordedPollTooltipCount',
  RECORD_POLL_ATTEMPTED = 'recordPollAttempted',
  USER = 'user',
  TOKEN = 'token',
  TOKEN_CAPS = 'TOKEN',
  RANDOMID = 'randomId',
  UUID = 'uuid',
  SERVER_TIME_DIFFERENCE = 'time-difference',
  NOTES_ENABLED_BATCH_IDS = 'notesEnabledBatchIds',
  PERIODIC_SYNC_ENABLE = 'periodicSyncEnable',
  VIDEO_ADS_DETAILS = 'videoAdsDetails',
  AD_VIEW_KEY = 'ad_viewed',
  CLIENT_ID = 'CLIENT_ID',
  VIDEO_COPILOT_SESSION_FEEDBACK_COUNTER = 'VIDEO_COPILOT_SESSION_FEEDBACK_COUNTER',
  VIDEO_COPILOT_IS_SHIMMER_EFFECT_SHOWN = 'VIDEO_COPILOT_IS_SHIMMER_EFFECT_SHOWN',
  PPJ_PROGRESS_CACHE = 'ppjProgressCache',
  BEFORE_TEST_URL = 'beforeTestUrl',
  // Add more keys as needed
}

export const isLocalHost = () => {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
};
export const reportParams = {
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
  SUBJECT: 'subject',
  MESSAGE: 'message',
  ORGANIZATION_ID: 'organizationId',
  BATCHSUBJECTSCHEDULEID: 'batchSubjectScheduleId',
  CONTENT_ID: 'contentId',
  OTT_VIDEO_ID: 'ottVideoId',
} as const;

export const typeParamValues = {
  BATCH_SUBJECT_SCHEDULE: 'BATCH_SUBJECT_SCHEDULE',
  CONTENT: 'CONTENT',
  OTT_VIDEO: 'OTT_VIDEO',
} as const;

export const VIDEO_COPILOT_SOURCE = {
  LECTURE: 'LECTURE',
  KHAZANA: 'KHAZANA',
  OTT: 'OTT',
} as const;

export const selfProfileDisplayOrder = {
  levelUpDisplayOrderOptional: 999,
  srkDisplayOrderOptional: 999,
};
